// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"f70f4849","362":"f70f4849","403":"f70f4849","425":"f70f4849","519":"f70f4849","689":"f70f4849"}[chunkId] + ".chunk.css";
};